const appEnv = process.env.REACT_APP_ENV;

const isNotProduction = appEnv !== 'production';

export const featureFlags = {
  covelotaf: isNotProduction,
};
